import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { ICmsAccountBannerResponse } from "../../Orchestrator/Types/Interface/ICmsAccountBanner";

export const getCmsAccountBanner = async () => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsAccountBannerAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("locale", locale);
  params.append("populate", "image");

  const endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsAccountBannerResponse>(endpointWithParams, "GET");
};
